import { Component, OnInit, Self, Input } from '@angular/core';
import { FmUploaderService } from '../file-uploader/fm-uploader.service';
import { NgOnDestroyService } from '../services/ng-on-destroy.service';
import { takeUntil } from 'rxjs/operators';
import { DialogService, UploadErrorsDialogComponent } from '../../dialogs/index';
import { FileUploadError } from '../models/FileUploadError';
import { TranslateService } from '@ngx-translate/core';
import { FileModel } from '../../typescript-angular-client/model/models';

@Component({
  selector: 'uploader-progress',
  templateUrl: './upload-progress.component.html',
  styleUrls: ['./upload-progress.component.scss'],
  providers: [NgOnDestroyService]
})
export class UploadProgressComponent implements OnInit {
  public currentFileIndex = 0;
  public numberFiles: number;
  public status: boolean;
  public resultNumberFiles: number;
  public endUploading = false;
  public errors: FileUploadError[] = [];
  readonly imageDialogType = FileModel.FileTypeEnum.IMAGES;
  private timer: NodeJS.Timer;

  @Input() dialogType = FileModel.FileTypeEnum.IMAGES;
  @Input() hideAfter = 30000;

  constructor(
    private fmupload: FmUploaderService,
    @Self() private NgOnDestroy$: NgOnDestroyService,
    private dialogService: DialogService,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.fmupload.onStart$.pipe(takeUntil(this.NgOnDestroy$)).subscribe((i) => {
      this.numberFiles = i;
      this.currentFileIndex = 0;
      this.endUploading = false;
      this.resultNumberFiles = 0;
      this.status = true;
    });
    this.fmupload.onProgress$.pipe(takeUntil(this.NgOnDestroy$)).subscribe(() => {
      this.currentFileIndex += 1;
    });
    this.fmupload.completedAll$.pipe(takeUntil(this.NgOnDestroy$)).subscribe((result) => {
      this.endUploading = true;
      this.resultNumberFiles = this.numberFiles <= 0 ? 0 : this.numberFiles - result.length;
      this.errors = result;
      this.timer = setTimeout(() => this.finish(), this.hideAfter);
    });
  }

  public openUploadErrors = (): void => {
    clearTimeout(this.timer);
    this.dialogService.createDialog(UploadErrorsDialogComponent, { files: this.errors }, {})
      .onClose.subscribe(() => this.timer = setTimeout(() => this.finish(), this.hideAfter));
  }

  public getStyle = () => {
    const progress = this.endUploading ? 100 : Math.round((this.currentFileIndex * 100) / this.numberFiles);
    return { width: `${progress}%` };
  }

  public getUploadedFileTypeTerm = (): string => {
    if (this.dialogType === FileModel.FileTypeEnum.IMAGES) {
      if (this.numberFiles > 1) {
        return this.translate.instant('COMMON.DIALOGS.FILE_MANAGER.IMAGE_PLURAL');
      } else {
        return this.translate.instant('COMMON.DIALOGS.FILE_MANAGER.IMAGE_SINGULAR');
      }
    } else {
      if (this.numberFiles > 1) {
        return this.translate.instant('COMMON.DIALOGS.FILE_MANAGER.FILE_PLURAL');
      } else {
        return this.translate.instant('COMMON.DIALOGS.FILE_MANAGER.FILE_SINGULAR');
      }
    }
  }

  public finish = (): void => {
    this.status = false;
    this.currentFileIndex = 0;
    this.endUploading = false;
    this.numberFiles = 0;
    this.resultNumberFiles = 0;
    this.errors = [];
    this.fmupload.clear();
  }

}
